// Configuration injectée par wp_localize_script + regex email partagée.

export const Cfg = window.ProbotSoum || {
	restUrl: '/wp-json/probot-soum/v1/',
	nonce: '',
	lang: 'fr',
	baseAirport: 'YQB',
	hoursPerDay: 8,
};

// Hours billed per technician-day. Sourced from the WP setting
// `hours_per_day` (Settings → Tarifs). Falls back to 8 if missing/invalid.
export const HOURS_PER_DAY = ( function () {
	var v = parseFloat( Cfg.hoursPerDay );
	return ( v > 0 ) ? v : 8;
} )();

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
